import api from "./api.config";

const config = () => {
    return api
        .get(`/api/common/config`)
        .then((response) => {
            return response.data;
        });
};
const countries = () => {
    return api
        .get(`/api/common/countries`)
        .then((response) => {
            return response.data;
        });
};
const provinces = (country) => {
    return api
        .get(`/api/common/states?country=${country}`)
        .then((response) => {
            return response.data;
        });
};


const CommonService = {
    config,
    countries,
    provinces
};

export default CommonService;